import { createContext, useContext } from 'react';

import * as trackingEvents from './trackingEvents';
import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

interface ContextValue {
  navigationData: DrilldownNavItem;
}

export const TrackingContext = createContext<ContextValue | undefined>(undefined);

export const useTracking = () => {
  const context = useContext(TrackingContext);

  if (context === undefined) {
    throw new Error('useTracking must be used within a TrackingContextProvider');
  }

  const { navigationData } = context;

  return {
    onBack: trackingEvents.back,
    onSelect: (item: DrilldownNavItem) => {
      trackingEvents.selectItem(navigationData, item);
    },
    onClickLink: (evt: React.MouseEvent<HTMLAnchorElement>, item: DrilldownNavItem) => {
      trackingEvents.clickLink(evt, navigationData, item);
    },
  };
};
